import { render, staticRenderFns } from "./Create-Or-Update-Customer.vue?vue&type=template&id=10b21e60&"
import script from "./Create-Or-Update-Customer.vue?vue&type=script&lang=js&"
export * from "./Create-Or-Update-Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports